import React from 'react'
import moment from 'moment'
import TableSection from './TableSection'
import Event from './Event'
import Row from './Row'
import { humanizeKey, parseValue } from 'lib/transform-record'

const momentDateSetting = {
  lastDay: '[Yesterday]',
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  lastWeek: '[last] dddd (LL)',
  nextWeek: 'dddd',
  sameElse: 'LL'
}

const propertiesMapper = (props, rowProps) => {
  return Object.keys(props).map((key) =>
    <Row label={humanizeKey(key)} {...rowProps}>{parseValue(props[key])}</Row>
  )
}

const eventMapper = ({
   event,
   timestamp,
   properties
}) => {
  const eventType = event === 'Page Viewed' ? 'page' : 'event'
  const extra = moment(timestamp).format('h:mm a')
  const children = propertiesMapper(properties, { type: 'table' })

  if (eventType === 'page') {
    return {
      title: properties.path,
      extra,
      type: eventType,
      children
    }
  }

  return {
    title: event,
    extra,
    type: eventType,
    children
  }
}

const Events = ({ events, collapsible = true }) => {
  const groups = {}

  events.forEach(e => {
    const key = moment(e.timestamp).format('YYYYMMDD')
    groups[key] = groups[key] || []
    groups[key].push(e)
  })

  let groupIndex = 0

  return (
    <div>
      {Object.keys(groups).map((key) => {
        const events = groups[key]
        const title = moment(key, 'YYYYMMDD').calendar(null, momentDateSetting)
        const extra = `${events.length} ${events.length > 1 ? 'events' : 'event'}`

        groupIndex++

        return (
          <TableSection collapsible={collapsible} key={key} title={title} extra={extra} isOpen={groupIndex < 4}>
            {events.map(e =>
              <Event key={e.message_id} {...eventMapper(e)} />
            )}
          </TableSection>
        )
      })}
    </div>
  )
}

export default Events



// WEBPACK FOOTER //
// ./components/Customers/presentational/Events.js